import { createI18n } from '@tencent/wphk-i18n';
import type { VueConstructor } from 'vue';
import zhHkConfig from '@/i18n/zh-hk/main.json';
import zhCnConfig from '@/i18n/zh-cn/main.json';
import enConfig from '@/i18n/en/main.json';

const { i18n } = createI18n({
  'zh-hk': zhHkConfig,
  'zh-cn': zhCnConfig,
  en: enConfig,
});

export { i18n };

export const install = {
  install: (Vue: VueConstructor) => {
    Vue.prototype.$t = (key: string, data?: object) => i18n(key, data);
  },
};
